import React from 'react';
import {useParams, useHistory} from 'react-router-dom';
import FlightSeatMap from './FlightSeatMap';

/**
 * Wrapper that reads the :id param from /flightsedit/:id/seat-map
 * and passes it as flightId to the seat map component.
 * The main FlightSeatMap expects :flightId from /flights/seat-map/:flightId.
 * This wrapper bridges the two route patterns.
 */
const FlightSeatMapWrapper = () => {
  const {id} = useParams<{id: string}>();
  // We render the seat map by navigating to the primary route
  // But instead, let's just redirect params via a shared approach.
  // Since FlightSeatMap reads `flightId` from params, we render it
  // inside a route that provides flightId. Instead, let's just
  // use the Redirect pattern or inline the logic.
  
  // Actually, the simplest approach: redirect to the primary seat map route
  const history = useHistory();
  
  React.useEffect(() => {
    if (id) {
      history.replace(`/flights/seat-map/${id}`);
    }
  }, [id, history]);
  
  return null;
};

export default FlightSeatMapWrapper;
